// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"e804f777","313":"5e050401","333":"913fe660","385":"e246f91f","444":"a9f1e578","758":"ed178171"}[chunkId] + ".chunk.js";
};